import React from "react";
import { logoVideos } from "../../utils/Dummy";
import nodata from "../../assets/img/nodata_icon.webp";

const Animation = ({ selectedFilter }) => {
  const data = logoVideos.filter((item) => {
    if (selectedFilter === "all") return item;
    return item.category === selectedFilter;
  });

  return (
    <div>
      {data?.length > 0 ? (
        <section
          className="mx-auto py-[10px] grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1  gap-10 my-10"
          data-aos="fade-right"
          data-aos-delay="800"
        >
          {data.map((video, index) => (
            <div key={index}>
              <div className="flex justify-center items-center h-[350px] w-full overflow-hidden rounded-xl shadow-xl p-4 bg-gifWhite">
                <img
                  src={video.src}
                  alt={video.name}
                  className="w=full h-auto"
                />
              </div>

              <p className="mt-4 text-xl font-semibold">{video.name}</p>
            </div>
          ))}
        </section>
      ) : (
        <div className="flex justify-center items-center mt-10">
          <img src={nodata} alt="nodata" />
        </div>
      )}
    </div>
  );
};

export default Animation;
